import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _dropWhile from 'lodash/dropWhile';
import cn from 'classnames';

import { ruleType } from 'types';
import './style.scss';

class GroupListItem extends Component {
  static propTypes = {
    index: PropTypes.number,
    rules: PropTypes.arrayOf(ruleType).isRequired,
    onUpdateRules: PropTypes.func,
    groupOrder: PropTypes.number,
    model: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  };

  state = {
    isHovered: false,
  };

  handleMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  handleDelete = () => {
    const { model, onUpdateRules, rules } = this.props;
    onUpdateRules(_dropWhile(rules, model));
  };

  render() {
    const { model, groupOrder, index } = this.props;
    const { isHovered } = this.state;
    /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events,
jsx-a11y/interactive-element-interactions */
    return (
      <div
        styleName={cn('item', {
          'is-active': isHovered,
        })}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div styleName="number">
          <span>{`${groupOrder + 1}.${index + 1}`}</span>
        </div>
        <div styleName="name-block">
          <div styleName="name">{model.name}</div>

          <div styleName="right">
            {isHovered && (
              <span
                styleName="delete"
                className="icon-trash-bin"
                onClick={this.handleDelete}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GroupListItem;
